import {
  SetErrorAction,
  SetPhaseAction,
  SetShouldShowErrorsAction,
  SetSourceNameAction,
  SetTextContentAction,
  TextAction,
  TextActionType,
} from "@/pages/sources/components/create/sources/text/actions";
import { CreateSourceTextState } from "@/pages/sources/components/create/sources/text/types";

function setSourceName(
  state: CreateSourceTextState,
  action: SetSourceNameAction,
): CreateSourceTextState {
  return {
    ...state,
    sourceName: action.payload,
  };
}

function setTextContent(
  state: CreateSourceTextState,
  action: SetTextContentAction,
): CreateSourceTextState {
  return {
    ...state,
    textContent: action.payload,
  };
}

function setShouldShowErrors(
  state: CreateSourceTextState,
  action: SetShouldShowErrorsAction,
): CreateSourceTextState {
  return {
    ...state,
    shouldShowErrors: action.payload,
  };
}

function setPhase(state: CreateSourceTextState, action: SetPhaseAction): CreateSourceTextState {
  return {
    ...state,
    phase: action.payload,
  };
}

function setError(state: CreateSourceTextState, action: SetErrorAction): CreateSourceTextState {
  return {
    ...state,
    error: action.payload,
  };
}

const createSourceTextReducer = (
  state: CreateSourceTextState,
  action: TextAction,
): CreateSourceTextState => {
  switch (action.type) {
    case TextActionType.SET_SOURCE_NAME:
      return setSourceName(state, action);
    case TextActionType.SET_TEXT_CONTENT:
      return setTextContent(state, action);
    case TextActionType.SET_SHOULD_SHOW_ERRORS:
      return setShouldShowErrors(state, action);
    case TextActionType.SET_PHASE:
      return setPhase(state, action);
    case TextActionType.SET_ERROR:
      return setError(state, action);
  }
};

export default createSourceTextReducer;
